import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const Icon = props =>
  <SvgIcon viewBox="0 0 507.451 507.45" {...props}>
    <path d="M440.813 280.5c0-7.65 2.55-15.3 2.55-25.5s0-17.85-2.55-25.5l53.55-43.35c5.1-5.1 5.1-10.2 2.55-15.3l-51-89.25c-2.55-2.55-7.65-5.1-15.3-2.55l-63.75 25.5c-12.75-10.2-28.05-17.85-43.35-25.5l-10.2-66.3c2.55-7.65-5.1-12.75-10.2-12.75h-102c-5.1 0-12.75 5.1-12.75 10.2l-10.2 68.85c-15.3 5.1-28.05 15.3-43.35 25.5l-61.2-25.5c-7.65-2.55-12.75 0-17.85 5.1l-51 89.25c-2.55 2.55 0 10.2 5.1 15.3l53.55 40.8c0 7.65-2.55 15.3-2.55 25.5s0 17.85 2.55 25.5l-53.55 43.35c-5.1 5.1-5.1 10.2-2.55 15.3l51 89.25c2.55 2.55 7.648 5.1 15.3 2.55l63.75-25.5c12.75 10.2 28.05 17.85 43.35 25.5l10.2 66.3c0 5.1 5.1 10.2 12.75 10.2h102c5.1 0 12.75-5.1 12.75-10.2l10.2-66.3c15.3-7.65 30.6-15.3 43.35-25.5l63.75 25.5c5.1 2.55 12.75 0 15.3-5.1l51-89.25c2.55-5.1 2.55-12.75-2.55-15.3l-58.65-40.8zm-188.7 63.75c-48.45 0-89.25-40.8-89.25-89.25s40.8-89.25 89.25-89.25 89.25 40.8 89.25 89.25-40.8 89.25-89.25 89.25z" />
  </SvgIcon>;

export default Icon;



// WEBPACK FOOTER //
// ./src/options/icons/Cog.jsx